import { render, staticRenderFns } from "./ClassSgin.vue?vue&type=template&id=142e347f&scoped=true&"
import script from "./ClassSgin.vue?vue&type=script&lang=js&"
export * from "./ClassSgin.vue?vue&type=script&lang=js&"
import style0 from "./ClassSgin.vue?vue&type=style&index=0&id=142e347f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e347f",
  null
  
)

export default component.exports